"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var nowrap = function nowrap(props) {
  return props.nowrap ? {
    whiteSpace: 'nowrap'
  } : null;
};

var accessiblyHide = function accessiblyHide(props) {
  return props.hidden ? {
    position: 'absolute',
    width: '1px',
    height: '1px',
    clip: 'rect(1px, 1px, 1px, 1px)'
  } : null;
};

var Label = _styledComponents["default"].label(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  margin-bottom: 4px;\n  ", ";\n  color: ", ";\n  ", "\n  ", " ", " ", " ", ";\n  ", "\n  ", "\n\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('label')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
}, function (props) {
  return props.bg ? "background-color: ".concat((0, _utils.getPalette)(props.bg)(props), ";") : '';
}, _styledSystem.space, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.width, nowrap, accessiblyHide, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
});

Label.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _styledSystem.space.propTypes), _styledSystem.fontSize.propTypes), _styledSystem.fontWeight.propTypes), _styledSystem.width.propTypes), {}, {
  children: _propTypes["default"].node,
  hidden: _propTypes["default"].bool,
  whiteSpace: _propTypes["default"].string
});
Label.defaultProps = {};
Label.displayName = 'Label';
Label.isLabel = true;
var _default = Label;
exports["default"] = _default;